import type { Color } from "@pdfking/math"

export type PrintLayer =
  | {
      enum: "overlay"
      order: number
      print_color: Color
      print_roughness: number
    }
  | {
      enum: "print"
      order: number
    }
